import { render, staticRenderFns } from "./Preparation.vue?vue&type=template&id=74085a88&"
import script from "./Preparation.vue?vue&type=script&lang=ts&"
export * from "./Preparation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports